import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useBookId } from "@/hooks/use-book-id"

import { fetchPipeline, fetchPipelines } from "./api"

export function useFetchPipelines(bookIdOverride?: string, enabled = true, options?: { scope?: "company" }) {
  const urlBookId = useBookId()
  const bookId = bookIdOverride ?? urlBookId
  const getContext = useApiContext(bookIdOverride)
  const scopeSegment = options?.scope === "company" ? "company" : (bookId ?? "company")

  const queryKey = ["pipelines", scopeSegment]

  return useQuery({
    queryKey,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context")
      return fetchPipelines(context, options)
    },
    enabled,
  })
}

export function useFetchPipeline(pipelineId: string, enabled = true, bookIdOverride?: string) {
  const urlBookId = useBookId()
  const bookId = bookIdOverride ?? urlBookId
  const getContext = useApiContext(bookIdOverride)

  return useQuery({
    queryKey: ["pipeline", pipelineId, bookId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context")
      return fetchPipeline(context, pipelineId)
    },
    enabled: enabled && !!pipelineId,
  })
}
